var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdc-menu mdc-menu-surface"},[_c('m-list',{attrs:{"menu":"","items":_vm.items,"aria-hidden":true,"aria-orientation":"vertical","tabindex":"-1"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }